import { Breadcrumb } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
	periodic_id?: string;
	in_editions?: boolean;
	edition_id?: string;
	new_edition?: boolean;
}

export const EditionsBreadcrumb: FC<IProps> = ({ periodic_id, edition_id, in_editions, new_edition }) => (
	<Breadcrumb>
		<Breadcrumb.Item key='periodics'>
			<Link to={'/conteudos/revistas'}>Revistas</Link>
		</Breadcrumb.Item>

		<Breadcrumb.Item key='periodic_title'>
			<Link to={`/conteudos/revistas/${periodic_id}`}>{periodic_id}</Link>
		</Breadcrumb.Item>

		{in_editions && (
			<Breadcrumb.Item key='edition_id'>
				<Link to={`/conteudos/revistas/${periodic_id}/edicoes`}>Edições</Link>
			</Breadcrumb.Item>
		)}

		{new_edition && <Breadcrumb.Item key='new_edition'>novo</Breadcrumb.Item>}

		{edition_id && (
			<Breadcrumb.Item key='edition_id'>
				<Link to={`/conteudos/revistas/${periodic_id}/edicoes/${edition_id}`}>{edition_id}</Link>
			</Breadcrumb.Item>
		)}
	</Breadcrumb>
);
